import { render, staticRenderFns } from "./ChallengeHome.vue?vue&type=template&id=c0d2fce6&scoped=true&"
import script from "./ChallengeHome.vue?vue&type=script&lang=js&"
export * from "./ChallengeHome.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeHome.vue?vue&type=style&index=0&id=c0d2fce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d2fce6",
  null
  
)

export default component.exports